import { Link } from 'react-router-dom';
import { aboutData } from '@/mocks/about';

const footerLinks = [
  {
    title: '内容板块',
    links: [
      { label: '人物分析', href: '/category/renwu-fenxi' },
      { label: '故事合集', href: '/category/gushi-heji' },
      { label: '创作灵感', href: '/category/chuangzuo-linggan' },
      { label: '情感逻辑', href: '/category/qinggan-luoji' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '口碑评价', href: '/about#reputation' },
      { label: '联系我们', href: '/about#contact' },
    ],
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                好色小姨
              </span>
              <span className="text-sm text-foreground-500 ml-2">故事集</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              都市情感故事的深度解读平台，专注于「好色小姨」经典角色类型的人物分析、故事合集、创作灵感与情感逻辑。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href={aboutData.socialLinks.weibo}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href={aboutData.socialLinks.zhihu}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 transition-colors"
                aria-label="知乎"
              >
                <i className="ri-zhihu-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">{group.title}</h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关注我们</h4>
            <p className="text-sm text-foreground-600 mb-2">
              微信：{aboutData.contactWechat}
            </p>
            <p className="text-sm text-foreground-600">
              邮箱：{aboutData.contactEmail}
            </p>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {aboutData.brandName}. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>京ICP备2026XXXXXX号</span>
            <span>京公网安备 110XXXXXXXX号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}